// B-1946 (23-oct-2026, t419) · EN LA APP DE ANDROID, SI EL BUSCA NO PUEDE SALIR A PANTALLA COMPLETA, SE DICE Y SE ARREGLA
// Debajo de los botones del busca que te está sonando (components/busca/BuscaEntrante): una línea y «Activarlo», que abre
// el ajuste «Notificaciones a pantalla completa» de la app. Al volver de los ajustes se vuelve a preguntar. Fuera de la
// app de Android con el complemento nativo del busca no sale nunca (utils/buscaNativo).
import { useEffect, useState } from 'react'
import { abrirAjustesPantallaCompleta, estadoDelBuscaNativo, faltaPantallaCompleta } from '../../utils/buscaNativo'
import { t } from '../../utils/i18n'   // B-2259 · los textos, en el idioma de quien mira (utils/i18n)

export default function AvisoPantallaCompleta() {
  const [falta, setFalta] = useState(false)
  useEffect(() => {
    let vivo = true
    const mirar = () => estadoDelBuscaNativo().then((e) => { if (vivo) setFalta(faltaPantallaCompleta(e)) }).catch(() => {})
    mirar()
    const conDoc = typeof document !== 'undefined' && typeof document.addEventListener === 'function'
    const alVolver = () => { if (typeof document === 'undefined' || document.visibilityState !== 'hidden') mirar() }
    if (conDoc) document.addEventListener('visibilitychange', alVolver)
    return () => { vivo = false; if (conDoc) document.removeEventListener('visibilitychange', alVolver) }
  }, [])
  if (!falta) return null
  return (
    <div data-aviso-pantalla-completa style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', fontSize: 13, color: 'var(--text-secondary)', background: 'var(--surface-2)', borderRadius: 10, padding: '8px 10px' }}>
      <span style={{ flex: '1 1 200px', minWidth: 0 }}>
        {t('components.busca.AvisoPantallaCompleta.en_este_movil_el_busca', 'En este móvil el busca no sale a pantalla completa con la pantalla bloqueada: suena y vibra igual, pero arriba.')}
      </span>
      <button type="button" data-activar-pantalla-completa onClick={() => { abrirAjustesPantallaCompleta() }}
        style={{ border: 'none', background: 'transparent', color: 'var(--primary)', fontWeight: 700, fontSize: 13, cursor: 'pointer', padding: 0 }}>
        {t('components.busca.AvisoPantallaCompleta.activarlo', 'Activarlo')}
      </button>
    </div>
  )
}
